import { Component, OnInit, enableProdMode } from '@angular/core';
import { Bill, Service } from '../receipt.service';

if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

@Component({
  selector: 'app-doctranslog',
  templateUrl: './doctranslog.component.html',
  styleUrls: ['./doctranslog.component.scss'],
  providers: [Service],
})
export class DoctranslogComponent {

  bills: Bill[] | any;

  constructor(service: Service) {
    this.bills = service.getBill();
    console.log(this.bills);
  }

}
